module.exports = __webpack_public_path__ + "static/scale-model-of-adventureworks-zipline-forest-in-nashville-tennessee-fdd2d59f3b480fb0d46dd60f77880909.png";